module.exports = __webpack_public_path__ + "img/story_slide_3_on.b0491cd0.jpg";